
<div class="d-flex flex-column" :style="'height: ' + height + 'px'">

    <div v-if="attachment && attachment.adpStatus" class="adp-strip flex-shrink-0 px-3 py-1">
        <div class="v-flex align-center">
            <v-icon small :color="adpStatusColor" class="mr-1">{{ adpStatusIcon }}</v-icon>
            <span class="body-2">{{ adpStatusLabel }}</span>
            <v-spacer />
            <template v-if="hasConfidenceScore">
                <span class="body-2 grey--text">{{ $t('inb.adp.confidence') }}: {{ confidencePct }}%</span>
            </template>
        </div>
    </div>

    <div class="lm-border pa-1 flex-grow-1" style="overflow: hidden">
        <c-inbox-assessment
            v-if      = "isAssessment"
            :item     = "attachment"
            :readonly = "readonly"
            class     = "white w-100 h-100"
            @morph    = "onMorph"
            @context  = "onContext"
            @changed  = "onChanged"
            ref       = "message"
        />
        <c-inbox-invoice
            v-if      = "isInvoice"
            :item     = "attachment"
            :readonly = "readonly"
            class     = "white w-100 h-100"
            @morph    = "onMorph"
            @context  = "onContext"
            ref       = "message"
        />
        <c-inbox-incident
            v-if      = "isIncident"
            :item     = "attachment"
            :readonly = "readonly"
            class     = "white w-100 h-100"
            @morph    = "onMorph"
            @context  = "onContext"
            ref       = "message"
        />
        <c-inbox-maintenance
            v-if      = "isMaintenance"
            :item     = "attachment"
            :readonly = "readonly"
            class     = "white w-100 h-100"
            @morph    = "onMorph"
            @context  = "onContext"
            ref       = "message"
        />
        <c-inbox-default
            v-if      = "isDefault"
            :item     = "attachment"
            :readonly = "readonly"
            class     = "white w-100 h-100"
            ref       = "message"
            @morph    = "onMorph"
            @context  = "onContext"
        />
    </div>

</div>
